import { createFileRoute, Link } from "@tanstack/react-router";
import { CheckCircle2, Phone } from "lucide-react";
import { BUSINESS } from "@/components/site/constants";
import { canonical } from "@/components/site/site-config";

export const Route = createFileRoute("/thank-you")({
  head: () => ({
    meta: [
      { title: "Thank You — Request Received | Destination Roofing Inc." },
      { name: "description", content: "Your Free Roof Inspection request was received. Destination Roofing will contact you shortly." },
      { name: "robots", content: "noindex,nofollow" },
      { property: "og:title", content: "Thank You — Request Received" },
      { property: "og:url", content: canonical("/thank-you") },
    ],
    links: [{ rel: "canonical", href: canonical("/thank-you") }],
  }),
  component: ThankYou,
});

function ThankYou() {
  return (
    <section className="mx-auto max-w-2xl px-4 py-20 md:py-28 text-center">
      <div className="rounded-2xl border border-border bg-white p-8 md:p-12 shadow-[var(--shadow-card)]">
        <CheckCircle2 className="size-14 text-trust mx-auto" />
        <h1 className="mt-5 text-3xl md:text-4xl font-display font-bold">Thank you — your request was received</h1>
        <p className="mt-4 text-muted-foreground">
          A team member from Destination Roofing Inc. will contact you shortly to schedule your Free Roof Inspection & Estimate.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center items-center">
          <a href={BUSINESS.phoneHref} className="btn-cta">
            <Phone className="size-4" /> Call {BUSINESS.phone}
          </a>
          <Link to="/" className="inline-flex items-center justify-center rounded-md border border-input bg-background px-4 py-2 text-sm font-medium min-h-12">
            Back to home
          </Link>
        </div>
        <p className="mt-6 text-xs text-muted-foreground">
          Prefer to talk right now? Call us at{" "}
          <a href={BUSINESS.phoneHref} className="text-brand underline">{BUSINESS.phone}</a>. Mon–Sat 6:30 AM–5:00 PM.
        </p>
      </div>
    </section>
  );
}
